import { Card, CardActions, CardContent, Icon, Typography } from '@/ui';

import type { FC } from 'react';

import Create from '@/components/Document/Create';
import Upload from '@/components/Documents/Upload';

interface EmptyProps {
  maxDocumentsReached?: boolean;
  uploadDisabled?: boolean;
}

const Empty: FC<EmptyProps> = ({
  maxDocumentsReached = false,
  uploadDisabled = false,
}) => (
  <Card>
    <CardContent>
      <div className="mb-4 grid size-12 place-items-center rounded-full bg-sage-200">
        <Icon className="!text-2xl text-sage-600">article</Icon>
      </div>
      <Typography className="mb-2" variant="h5">
        There are no documents shared yet.
      </Typography>
      <Typography className="mb-5" variant="body2">
        Start by creating a new document or uploading an existing one.
      </Typography>
    </CardContent>
    <CardActions className="pb-6">
      <Create maxDocumentsReached={maxDocumentsReached} />
      <Upload
        disabled={uploadDisabled}
        maxDocumentsReached={maxDocumentsReached}
      />
    </CardActions>
  </Card>
);

export default Empty;
